import axios from "axios";
import { ElMessage, ElMessageBox } from "element-plus";
import store from "@/store";
import { getToken, removeToken } from "@/utils/auth";
import router from "@/router";
import { API_ROOT, apiVersion } from "@/config";

// 创建 axios 实例
const service = axios.create({
  baseURL: API_ROOT || "/api",
  timeout: 30000,
});

// 请求拦截器
service.interceptors.request.use(
  (config) => {
    // 在发送请求之前做些什么
    if (localStorage.getItem("token")) {
      // 让每个请求携带token
      config.headers.token = "Bearer " + localStorage.getItem("token");
    }
    return config;
  },
  (error) => {
    // 处理请求错误
    console.log(error);
    return Promise.reject(error);
  }
);
// 响应拦截器
service.interceptors.response.use(
  (response) => {
    const res = response.data;
    // 这里可以根据实际后端接口返回格式修改
    // 假设后端返回格式为 { code: 200, data: {}, msg: '' }
    if (res.code === 1 || res.code === "0000") {
      return res;
    }
    // 1002: 非法token、token过期;
    if (
      (res.code === 1001 || res.code === 1002 || res.code === 1003) &&
      !Vue.prototype.$tokenExpiredAlertShown
    ) {
      Vue.prototype.$tokenExpiredAlertShown = true;
      ElMessageBox.confirm(
        "登录状态已过期，您可以继续留在该页面，或者重新登录",
        "确定登出",
        {
          confirmButtonText: "重新登录",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          localStorage.clear();
          window.open("/login", "_self");
          return false;
        })
        .catch(() => {
          return false;
        });
      // 5秒后重置标记
      setTimeout(() => {
        Vue.prototype.$tokenExpiredAlertShown = false;
      }, 5000);
      return false;
    }

    if (res.code === "500") {
      ElMessage.error(res.msg);

      return Promise.reject(res.msg);
    } else {
      return res;
    }
  },
  (error) => {
    ElMessage.error(error.msg);
    return Promise.reject(error);
  }
);

export default service;
